import React from 'react';
import ServiceListFunctional from './components/service-list-functional';

const ServiceList = () => {
	return <ServiceListFunctional />;
};

export default ServiceList;
